"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";
import * as C from "@/components";
import Link from "next/link";
import VadImage from "vadimages-nextjs-image-optimizer";

const imageDirectory = `/images/european-lander/`;

export const ProductsAvailableFromGlobalFacilities = () => {
  const { productsAvailableFromOurGlobalFacilities, viewLink } = useTranslations();

  return (
    <C.PageSection>
      <C.Card className="pt-6 md:pt-20">
        <h2 className="text-new-black-domina text-center max-w-[750px] mx-auto mb-10">
          {productsAvailableFromOurGlobalFacilities}
        </h2>
        <div className="flex items-center justify-center mb-4">
          <Link href="/products" target="_blank" className="btn-yellow-arrow">
            <span>{viewLink}</span>
          </Link>
        </div>
        <VadImage
          src={`${imageDirectory}global-facilities.png`}
          alt="Global Facilities"
          width={924}
          height={656}
          className="mx-auto pl-10"
        />
      </C.Card>
    </C.PageSection>
  );
};
